enum ProgramType {
  Gfc = 'GFC',
  GfcEu = 'GfcEu',
  GfcJp = 'GfcJp',
  Go = 'Go',
  QuickCommerce = 'QuickCommerce',
  Ssd = 'Ssd',
  WholeFoods = 'WholeFoods',
}

export default ProgramType;
